<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="user-chip"
          color="primary"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          <v-avatar>
            <v-icon>info</v-icon>
          </v-avatar>
          <v-progress-circular
            v-if="loading"
            :size="15"
            color="white"
            indeterminate
          />
          <span v-else>
            {{ strategyName }} <b>({{ strategyType }})</b>
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Open or Copy Strategy
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'StrategyChip',
  props: {
    id: {
      type: String,
      default: null,
      required: true,
    },
    strategy: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentStrategy: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  computed: {
    strategyName() {
      if (this.strategy) {
        return this.strategy.strategyName;
      }

      if (this.currentStrategy) {
        return this.currentStrategy.strategyName;
      }

      return '';
    },
    strategyId() {
      if (this.strategy) {
        return this.strategy.id;
      }

      if (this.currentStrategy) {
        return this.currentStrategy.id;
      }

      return '';
    },
    strategyType() {
      if (this.strategy) {
        return this.strategy.type;
      }

      if (this.currentStrategy) {
        return this.currentStrategy.type;
      }

      return '';
    },
  },
  mounted() {
    if (this.strategy) {
      return;
    }

    this.fetchStrategy();
  },
  methods: {
    ...mapActions([
      'fetchStrategyById',
    ]),

    async fetchStrategy() {
      this.loading = true;

      try {
        this.currentStrategy = await this.fetchStrategyById(this.id);
        this.loading = false;
      } catch (error) {
        this.currentStrategy = null;
        this.loading = false;
      }
    },
    onClick() {
      this.$router.push('/digitalDepots/accounts');
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/digitalDepot/StrategyChip.vue